import option from "@/page/maintenance/config/projectOption";
import progressOptions from "@/page/maintenance/config/progressOptions";

//项目类型
let getLegalTypeLabel = (typeId) => {
    let options = option.legalType;
    let result = {name: '', type: ''};
    options.forEach(item => {
        if(item.id === typeId) {
            result.name = item.name;
            result.type = item.type;
        }
    })
    return result;
}
// 工程分类
let getprojectTypeLabel = (typeId) => {
    let options = option.projectType;
    let result = '';
    options.forEach(item => {
        if(item.id === typeId) {
            result = item.name;
        }
    })
    return result;
}
let getprojectScheduleLabel = (typeId,isMaster) => {
    let options = option.projectSchedule;
    let result = {name: '', isMaster};
    options.forEach(item => {
        if(item.id === typeId) {
            result.name = item.name;
            result.master = isMaster;
        }
    })
    return result.name;
}
let getimpermanencyLabel = (typeId) => {
    let options = option.impermanency;
    let result = {name: '', type: ''};
    options.forEach(item => {
        if(item.id === typeId) {
            result.name = item.name;
            result.type = item.type;
        }
    })
    return result.name;
}
// 是否延期
let getIsDelay = (isDelay) => {
    let options = option.isDelay;
    let result = '';
    options.forEach(item => {
        if(item.id === (+(!!isDelay) + 1)) {
            result = item.name;
        }
    })
    return result;
}
// 施工阶段
let getStage = (typeId) => {
    let options = option.constructionStage;
    let result = '';
    options.forEach(item => {
        if(item.id === typeId) {
            result = item.name;
        }
    })
    return result;
}

export default {
    getLegalTypeLabel,
    getprojectTypeLabel,
    getprojectScheduleLabel,
    getimpermanencyLabel,
    getIsDelay,
    getStage
}

export {
    getLegalTypeLabel,
    getprojectTypeLabel,
    getprojectScheduleLabel,
    getimpermanencyLabel,
    getIsDelay,
    getStage
}


// WEBPACK FOOTER //
// ./src/filter/project.js